module.exports = __webpack_public_path__ + "img/Policy-page.717f517.svg";